import { ModuleStructure } from './../../../../models/module-structure';
import { RecordProperties } from './../../../record-model';
import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzSelectComponent } from 'ng-zorro-antd/select';
import { LayoutService } from 'src/app/layout/layout.service';
import * as g from 'src/app/globals';
import * as accounting from 'accounting';
@Component({
  selector: 'app-outbound-batch',
  templateUrl: './outbound-batch.component.html',
  styleUrls: ['./outbound-batch.component.less'],
})
export class OutboundBatchComponent implements OnInit {
  @ViewChild('batchSearch') batchSearch: ElementRef;
  @ViewChild('binLocation') binLocation: NzSelectComponent;

  batchNumbersVal = [];
  @Input() set batchNumbers(val: any[]) {
    this.batchNumbersVal = val;
  }

  get batchNumbers() {
    return this.batchNumbersVal;
  }

  @Output() batchNumbersChange = new EventEmitter();

  @Input() selectedQty: number;
  @Input() qtyProperty: RecordProperties;
  @Output() selectedQtyChange = new EventEmitter();

  @Input() requiredQty = 0;
  @Input() toBinActivated = false;
  @Input() toBinLocations = [];
  @Input() numPerSale = 1;
  @Input() moduleStructure: ModuleStructure;

  currentBatch: any = {};
  visibleBatchNumbers: any[];

  toBinLocationValue: number;
  batchSearchValue = '';
  selectedBatch;
  currentQuantity: number;

  dateFormat = g.companyConfiguration.DateFormat;

  constructor(
    private messageService: NzMessageService,
    private layoutService: LayoutService
  ) {}

  ngOnInit(): void {
    setTimeout(() => {
      if (this.toBinActivated) {
        this.binLocation.focus();
      } else {
        this.batchSearch.nativeElement.focus();
      }
    }, 1000);
  }

  searchForBatch(quantity, key?) {
    if (key !== undefined && key.keyCode !== 13) {
      return;
    }

    const index = this.batchNumbers.findIndex(
      (i) => i.DistNumber.toLowerCase() === this.batchSearchValue.toLowerCase()
    );

    if (index === -1) {
      this.selectedBatch = undefined;
      return;
    } else {
      if (this.selectedQty >= this.requiredQty) {
        this.messageService.error(
          this.layoutService.translate(
            'Selected quantity already is equal or greater than the required quantity.'
          )
        );

        return;
      }

      this.selectedBatch = this.batchNumbers[index];
      if (
        this.selectedBatch.SelectedQty === undefined ||
        this.selectedBatch.SelectedQty === null
      ) {
        this.selectedBatch.SelectedQty = 0;
      }

      setTimeout(() => {
        quantity.focus();
      }, 10);
    }
  }

  quantityInserted(batchControl, key?) {
    if (key !== undefined && key.keyCode !== 13) {
      return;
    }

    if (this.currentQuantity > this.requiredQty) {
      this.messageService.error(
        this.layoutService.translate(
          'Selected quantity exceeds the required quantity, we reset the quantity to the maximum allowed quantity.'
        )
      );
      this.playErrorVoice();
      this.requiredQty = this.currentQuantity;

      return;
    }

    this.selectedQty = 0;
    this.batchNumbers.forEach((batch) => {
      if (
        batch.SelectedQty === 0 ||
        batch.SelectedQty === undefined ||
        batch.SelectedQty === '' ||
        Number(batch.SelectedQty) === 0
      ) {
        return;
      }

      this.selectedQty += batch.SelectedQty;
    });

    if (this.selectedQty > this.requiredQty) {
      this.messageService.error(
        this.layoutService.translate(
          'Selected quantity exceeds the required quantity, we reset the quantity to the maximum allowed quantity.'
        )
      );
      this.playErrorVoice();
      this.requiredQty = this.selectedQty;

      if (this.selectedBatch !== null) {
        this.currentQuantity =
          this.currentQuantity - (this.selectedQty - this.requiredQty);
        this.selectedQty = this.requiredQty;
      }
    }

    if (
      this.selectedBatch !== undefined &&
      this.selectedBatch.Quantity / this.numPerSale <
        this.selectedBatch.SelectedQty + this.currentQuantity
    ) {
      this.messageService.error(
        this.layoutService.translate(
          'Selected quantity exceeds the available quantity in the batch.'
        )
      );
      this.playErrorVoice();
      return;
    }

    this.selectedBatch.SelectedQty += this.currentQuantity;
    if (this.toBinActivated) {
      if (this.selectedBatch['To-' + this.toBinLocationValue] === undefined) {
        this.selectedBatch['To-' + this.toBinLocationValue] = 0;
      }
      this.selectedBatch['To-' + this.toBinLocationValue] +=
        this.currentQuantity;
    }

    this.selectedBatch = undefined;
    this.currentQuantity = null;
    this.batchSearchValue = null;

    batchControl.focus();

    this.visibleBatchNumbers = this.batchNumbers.filter(
      (b) => b.SelectedQty > 0
    );

    this.selectedQtyChange.emit(this.selectedQty);
    this.batchNumbersChange.emit(this.batchNumbers);

    if (this.selectedQty === this.requiredQty) {
      // this.qtyProperty.ValueAsObject = this.selectedQty;
      const scope = this;
      this.qtyProperty.DialogVisible = false;
      setTimeout(() => {
        scope.qtyProperty.DialogVisibleDrawerInitialized = false;
      }, 50);
    }
  }

  selectedQtyChanged(batchNumber) {
    this.selectedQty = 0;
    this.batchNumbers.forEach((batch) => {
      if (
        batch.SelectedQty === 0 ||
        batch.SelectedQty === undefined ||
        batch.SelectedQty === '' ||
        Number(batch.SelectedQty) === 0
      ) {
        return;
      }

      this.selectedQty += batch.SelectedQty;
    });

    if (batchNumber.Quantity / this.numPerSale < batchNumber.SelectedQty) {
      this.messageService.error(
        this.layoutService.translate(
          'Selected quantity exceeds the available quantity in the batch.'
        )
      );
      this.playErrorVoice();
      if (batchNumber !== null) {
        setTimeout(() => {
          this.selectedQty -= batchNumber.SelectedQty;
          batchNumber.SelectedQty = 0;

          this.selectedQtyChange.emit(this.selectedQty);
          this.batchNumbersChange.emit(this.batchNumbers);
        }, 1);
      }

      return;
    }

    if (this.selectedQty > this.requiredQty) {
      this.messageService.error(
        this.layoutService.translate(
          'Selected quantity exceeds the required quantity, we reset the quantity to the maximum allowed quantity.'
        )
      );
      this.playErrorVoice();
      // this.requiredQty = this.selectedQty;

      if (batchNumber !== null) {
        setTimeout(() => {
          batchNumber.SelectedQty =
            batchNumber.SelectedQty - (this.selectedQty - this.requiredQty);

          this.selectedQty = this.requiredQty;
          this.selectedQtyChange.emit(this.selectedQty);
          this.batchNumbersChange.emit(this.batchNumbers);
        }, 1);
      }
    }

    this.selectedQtyChange.emit(this.selectedQty);
    this.batchNumbersChange.emit(this.batchNumbers);
  }

  playErrorVoice() {
    const audio = new Audio('assets/audio_file.mp3');
    audio.load();
    audio.play();
  }
  numberParser(value: string) {
    if (value == null) {
      return '';
    } else {
      return value.replace('%', '').replace(' ', '');
    }
  }

  formatter(value: number): string {
    if (value == null || isNaN(value)) {
      value = 0;
    }
    return accounting.formatNumber(
      value,
      g.companyConfiguration.QuantityDecimal,
      g.companyConfiguration.ThousandSep,
      g.companyConfiguration.DecimalSep
    );
  }
}
